"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishReason = void 0;
exports.FinishReason = {
    Complete: "COMPLETE",
    Error: "ERROR",
    ErrorToxic: "ERROR_TOXIC",
    ErrorLimit: "ERROR_LIMIT",
    UserCancel: "USER_CANCEL",
    MaxTokens: "MAX_TOKENS",
};
